import { useFormik } from "formik"
import { useEffect, useState } from "react"
import Modal from "../../../global/Modal/Modal"
import InputText from "../../../global/InputText/InputText"
import SimpleButton from "../../../global/SimpleButton/SimpleButton"
import { addEditDataAPI } from "../../../services/CRUDServices"
import { changePasswordValidation } from "global/Validation/Validation"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"

interface ChangePasswordModalProps {
  open: boolean
  setOpen: (value: boolean) => void
}

const ChangePasswordModal = ({ open, setOpen }: ChangePasswordModalProps) => {
  const [Loading, setLoading] = useState(false)
  const { userinfo } = useSelector((state: any) => state.userInfo)

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: changePasswordValidation,
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    onSubmit: (values) => {
      setLoading(true)
      addEditDataAPI(
        `/resource-api/users/${userinfo?.id}/change-password`,
        "put",
        values
      )
        .then(() => {
          setOpen(false)
          handleReset()
          toast.success("رمز عبور با موفقیت تغییر یافت")
        })
        .catch(() => {})
        .finally(() => setLoading(false))
    },
  })
  const {
    values,
    errors,
    touched,
    handleChange,
    handleSubmit,
    handleReset,
  }: any = formik

  useEffect(() => {
    handleReset()
  }, [open, handleReset])
  return (
    <Modal visible={open} setVisible={setOpen} title='تغییر رمز عبور'>
      <form onSubmit={handleSubmit} className='flex gap-5 mt-8 flex-col'>
        <InputText
          password
          important
          label='گذر واژه قبلی '
          values={values.oldPassword}
          name='oldPassword'
          handleChange={handleChange}
          error={touched.oldPassword && errors.oldPassword}
          dir='ltr'
        />
        <InputText
          password
          important
          label='گذر واژه جدید '
          values={values.newPassword}
          name='newPassword'
          handleChange={handleChange}
          error={touched.newPassword && errors.newPassword}
          dir='ltr'
        />
        <InputText
          password
          important
          label='تایید گذر واژه جدید'
          values={values.confirmPassword}
          name='confirmPassword'
          handleChange={handleChange}
          error={touched.confirmPassword && errors.confirmPassword}
          dir='ltr'
        />
        <SimpleButton
          text='ثبت'
          className='full-tomato-btn w-full'
          loading={Loading}
          type='submit'
        />
      </form>
    </Modal>
  )
}

export default ChangePasswordModal
